import { MakeCall } from './createMakeCall';

const addSavedSearch =
  (makeCall: MakeCall) => (userId: 'me' | number, data: unknown) =>
    makeCall<undefined>('POST', `/api/v2/user/${userId}/search`, {
      data,
    });
export { addSavedSearch };
